export default "__VITE_ASSET__qt2RZQL9__"